<template>
	<textarea v-model="joinedArray" rows="1" ref="area_tag" class="fd-lines" :readonly="readonly"></textarea>
</template>

<script setup lang="ts">
import autosize from "autosize";
import {computed, onMounted, ref} from "vue";
import type {PropType} from "vue";

const props = defineProps({
    modelValue: {
        type: Array as PropType<string[]>,
        default: []
    },
    maxLines: {
        type: Number,
        default: 0,
    },
    readonly: Boolean
});
const area_tag = ref<HTMLTextAreaElement | null>(null);
const emit = defineEmits(["update:modelValue"]);
const joinedArray = computed<string>({
    get() {
        return props.modelValue.join("\n");
    },
    set(v) {
        if (v == null || typeof v === "undefined") {
            emit("update:modelValue", []);
            return;
        }
        let array = v.split(/\n/);
        if (props.maxLines > 0) {
            if (array.length > props.maxLines) {
                array.splice(props.maxLines, array.length - props.maxLines);
            }
        }
        emit("update:modelValue", array);
    },
});

onMounted(() => {
    if (area_tag.value) autosize(area_tag.value);
});
</script>

<style>
.fd-lines {
	resize: none;
}
</style>
